import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () =>
			import('./components/view-list/view-list.component').then(
				(component) => component.ViewListComponent
			)
	}
];
